<template>
  <g :id="hand.id">
    <path fill="#332D2F" d="M74.64,110.9537c-0.5368,1.462-2.1571,2.212-3.6192,1.6752c-1.462-0.5368-2.212-2.1571-1.6752-3.6192
      c0.4078-1.1106,1.4654-1.8486,2.6484-1.848c1.5577,0.0011,2.8196,1.2647,2.8185,2.8224
      C74.8124,110.3149,74.754,110.6432,74.64,110.9537z M70.6482,109.4865c-0.2729,0.7429,0.1081,1.5665,0.8511,1.8393
      c0.7429,0.2729,1.5664-0.1081,1.8393-0.8511l0,0c0.2752-0.7421-0.1033-1.5668-0.8453-1.842
      c-0.7421-0.2752-1.5667,0.1032-1.842,0.8453C70.6503,109.4808,70.6493,109.4836,70.6482,109.4865z"/>
    <path fill="#595A5C" d="M69.3326,109.0017l0.0295,0.0108c0.5337-1.4538,2.1449-2.1998,3.5988-1.6661
      c1.4538,0.5337,2.1998,2.1449,1.6661,3.5988c-0.5337,1.4538-2.145,2.1998-3.5988,1.6661
      c-1.1037-0.4051-1.8374-1.4558-1.8378-2.6314c0.0001-0.3301,0.0582-0.6576,0.1718-0.9674L69.3326,109.0017 M73.3537,110.4807
      c0.2766-0.7511-0.1081-1.5842-0.8592-1.8607c-0.7511-0.2766-1.5841,0.1081-1.8607,0.8592
      c-0.2766,0.7511,0.1081,1.5842,0.8592,1.8607c0.1602,0.059,0.3296,0.0892,0.5003,0.0892
      C72.6013,111.4308,73.1451,111.0517,73.3537,110.4807 M69.3325,109.0019c-0.5405,1.4694,0.2125,3.0989,1.6819,3.6394
      c1.4694,0.5405,3.0989-0.2125,3.6395-1.682s-0.2125-3.0989-1.6819-3.6394c-0.3132-0.1152-0.6443-0.1742-0.978-0.1743
      C70.8048,107.1431,69.741,107.885,69.3325,109.0019z M73.3241,110.4697c-0.2698,0.7354-1.0848,1.1127-1.8201,0.8428
      c-0.7354-0.2698-1.1127-1.0847-0.8428-1.8201c0.2698-0.7354,1.0847-1.1127,1.8201-0.8428
      c0.5584,0.2049,0.9295,0.7364,0.9297,1.3312C73.411,110.1477,73.3816,110.3132,73.3241,110.4697z"/>
    <polygon fill="#FFFFFF" points="70.9432,107.1008 69.1655,95.2331 71.9996,71.1089 74.8258,95.2334 73.0455,107.1011 			"/>
    <path fill="#332D2F" d="M71.9992,74.7577l2.3987,20.4687l-1.7186,11.4486l-1.3699,0l-1.7153-11.4492l2.4053-20.4685
       M72.0006,67.4605l-3.2648,27.779l1.8406,12.286l2.8345,0l1.8442-12.2851L72,67.4607L72.0006,67.4605z"/>
    <polygon fill="#332D2F" points="74.1306,98.9256 73.4116,103.455 73.4114,107.9859 70.5764,107.9845 70.5772,103.4549
			69.8813,98.9246 		"/>
  </g>
</template>

<script>
export default {
  name: 'sdHandMinute',
  props: ['data'],
  computed: {
    hand() {
      if (this.data.hand) return this.data.hand;
    },
    watch() {
      if (this.data.watch) return this.data.watch;
    },
  },
};
</script>
